
import axios from 'axios'
import router from '../router'
import { MessageBox } from 'element-ui'
import {
    Loading
} from 'element-ui'

let needLoadingRequestCount = 0
let showFullScreenLoading = function () {
    if (needLoadingRequestCount === 0) {
        // startLoading();
    }
    needLoadingRequestCount++
}
let tryHideFullScreenLoading = function () {
    if (needLoadingRequestCount <= 0) {
        return
    }
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        // endLoading();
    }
}

let loading
let startLoading = function () {
    loading = Loading.service({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}
let endLoading = function () {
    loading.close()
}

// 请求拦截器
axios.interceptors.request.use(function (config) {
    showFullScreenLoading()
    let token = sessionStorage.getItem('tokenId')
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
    }
  // config.url  = 'http://192.168.205.123:8762' + config.url
    return config

}, function (error) {
    return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use(function (response) {
    let hadTip = sessionStorage.getItem("hadTip");
    // 401 定义为未登录的状态码
    if ("false" === hadTip && response.data.code === 401) {
        sessionStorage.setItem("hadTip", true);
        // 未授权，请重新登录哦  // 到登录页重新获取token
        let tips = "<i class='el-icon-warn-tip'></i> 请重新登陆";
        MessageBox.confirm(tips, "提示", {
            confirmButtonText: "好的",
            // customClass: "confirmClass-style",
            customClass: "customClass-style",
            iconClass: "",
            dangerouslyUseHTMLString: true,
            // confirmButtonClass: "confirm",
            confirmButtonClass: "confirm-style",
            showCancelButton: false,
        })
            .then(async () => {
                router.push({ path: '/login' });
            }).catch(() => {
                router.push({ path: '/login' });
            });
    }
    tryHideFullScreenLoading()
    return response
}, function (error) {   //登录失败异常
    // console.log(error);
    if (error.request) {
        let hadTip = sessionStorage.getItem("hadTip");
        if ("false" === hadTip && error.request.status == 401) {
            sessionStorage.setItem("hadTip", true);
            // 未授权，请重新登录哦  // 到登录页重新获取token
            let tips = "<i class='el-icon-warn-tip'></i>请重新登陆";
            MessageBox.confirm(tips, "提示", {
                confirmButtonText: "好的",
                // customClass: "confirmClass-style",
                customClass: "customClass-style",
                iconClass: "",
                dangerouslyUseHTMLString: true,
                // confirmButtonClass: "confirm",
                confirmButtonClass: "confirm-style",
                showCancelButton: false,
            })
                .then(async () => {
                    router.push({ path: '/login' });
                }).catch(() => {
                    router.push({ path: '/login' });
                });
        }
    } else if (error.response) {

    }
    return Promise.reject(error);
})

// 封装axios的post请求
export function postRequest(url, params) {
    return axios({
        method: 'post',
        url: `${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = ''
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Access-Control-Allow-Origin': '*'
        }
    })
}

// 封装axios的特殊post请求,将数组使用参数数组的方式上传
export function postRequest2(url, params) {
    return axios({
        method: 'post',
        url: `${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = ''
            for (let it in data) {
                if (data[it] instanceof Array) {
                    const dataArray = data[it];
                    if (null != dataArray && 0 < dataArray.length) {
                        for (let index = 0; index < dataArray.length; index++) {
                            const element = dataArray[index];
                            ret += encodeURIComponent(it + "[]") + '=' + encodeURIComponent(element) + '&';
                        }
                    }
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
                } else {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
                }
            }
            return ret
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Access-Control-Allow-Origin': '*'
        }
    })
}

// 封装axios的post json请求
export function postJsonRequest(url, params) {
    return axios({
        method: 'post',
        url: `${url}`,
        data: params,
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        }
    })
}

// 封装上传文件接口
export function uploadFileRequest(url, params) {
    return axios({
        method: 'post',
        url: `${url}`,
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*'
        }
    })
}
export function uploadFilePutRequest(url, params) {
    return axios({
        method: 'put',
        url: `${url}`,
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*'
        }
    })
}

// 封装put接口
export function putRequest(url, params) {
    return axios({
        method: 'put',
        url: `${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = ''
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Access-Control-Allow-Origin': '*'
        }
    })
}
// 封装axios的post json请求
export function putJsonRequest(url, params) {
    return axios({
        method: 'put',
        url: `${url}`,
        data: params,
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        }
    })
}
// 封装删除接口
export function deleteRequest(url) {
    return axios({
        method: 'delete',
        url: `${url}`
    })
}

// 封装get接口
export function getRequest(url) {
    return axios({
        method: 'get',
        url: `${url}`
    })
}



// WEBPACK FOOTER //
// ./src/axios/api.js